import { useEffect, useMemo, useState } from "react";

export function useMediaQuery(queryString: string): boolean {
	const mediaQueryList = useMemo(
		(): MediaQueryList => {
			return window.matchMedia(queryString);
		},
		[queryString]
	);

	const [doesMatchTheQuery, setDoesMatchTheQuery] = useState<boolean>(mediaQueryList.matches);

	useEffect(
		() => {
			const callback = (event: MediaQueryListEvent): void => {
				setDoesMatchTheQuery(event.matches);
			};
			mediaQueryList.addEventListener("change", callback);

			return () => mediaQueryList.removeEventListener("change", callback);
		},
		[mediaQueryList]
	);

	return doesMatchTheQuery;
}